import { Modal, ModalProps } from 'antd'

export const AppModal = ({ children, ...rest }: ModalProps) => {
  return (
    <Modal
      focusable={{
        focusTriggerAfterClose: false,
        trap: false,
      }}
      {...rest}
    >
      {children}
    </Modal>
  )
}
